import { render } from "./DocumentUploadIcon.vue?vue&type=template&id=32b34d87"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/DocumentUploadIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "32b34d87"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32b34d87', __exports__)) {
    api.reload('32b34d87', __exports__)
  }
  
  module.hot.accept("./DocumentUploadIcon.vue?vue&type=template&id=32b34d87", () => {
    api.rerender('32b34d87', render)
  })

}


export default __exports__